import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useCookies } from '@/node_modules/@vueuse/integrations/useCookies';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCookies',
  setup(__props) {

const cookies = useCookies(['accept-cookies']);
const isNotAccept = computed(() => !cookies.get('accept-cookies'));

const accept = () => {
  cookies.set('accept-cookies', true);
};

return { __sfc: true,cookies, isNotAccept, accept }
}

})